Vue.component('ak-relation-resolver', {
    functional: true,
    name: "AkRelationResolver",
    props: {
        relationString: {
            type: String,
            default: '',
            required: true
        },
        defaultIdsSelected: {
            type: Array,
            required: false,
            default: () => {return []}
        }
    },
    render(createElement, { props, listeners, slots }) {
        let relation = props.relationString.split(':');
        let currentType = relation.shift();
        let currentBundle = relation.shift();
        let currentDefinition = relation.shift();
        if(currentType == 'grid') {
            // if we need to render a grid
            let leftOverRelationString = relation.length ? relation.join(':') : undefined;

            return createElement("ak-stacked-window", {
                on: {
                    close: listeners.close,
                },
                scopedSlots: {
                    default: childProps => createElement('ak-relation-data-table', {
                        props: {
                            bundle: currentBundle,
                            definition: currentDefinition,
                            defaultIdsSelected: props.defaultIdsSelected,
                            childrelationString: leftOverRelationString
                        },
                        on: {
                            save: listeners.updateRelations,
                            close: childProps.close,
                        }
                    })
                }
            })
        } else if(currentType == 'form') {
            // if we have to render a form
            
            let currentObjectId = relation.shift();
            let leftOverRelationString = relation.length ? relation.join(':') : undefined;

            return createElement("ak-stacked-window", {
                on: {
                    close: listeners.close,
                },
                scopedSlots: {
                    default: childProps => createElement('ak-form', {
                        props: {
                            bundle: currentBundle,
                            definition: currentDefinition,
                            objectId: currentObjectId,
                            relationString: leftOverRelationString,
                        },
                        on: {
                            save: childProps.close,
                        },
                    })
                }
            });
        }
    }
}, false);